import { connect } from "react-redux";
import { IdPersistence } from "../../constants/IdPersistence";
import { selectCoopInfo } from "../../selectors/selectCoopInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { PlayerPreferencesPlatformType } from "../../utils/network/generated/protoTypes";
import { utilNumber } from "../../utils/utilNumber";
import { DialogConfirmation, } from "../generic/dialog-confirmation/DialogConfirmation";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionServerPersistenceSetInfo } from "../server-persistence/actionServerPersistence";
import { actionCoopInfoLeaveCoop } from "./actionCoop";
var mapState = function (state) {
    var coop = selectCoopInfo(state);
    var coopName = coop ? coop.name : "";
    var leaveCoopDescLoca = utilLoca
        .get(IdLoca.leaveCoop_desc)
        .replace(ReplacementLoca.zero_0, coopName);
    return {
        messageLocaId: leaveCoopDescLoca,
        primaryBtnLocaId: IdLoca.leave,
        titleLocaId: IdLoca.leaveCoop_title,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.CoopLeaveConfirm)); },
    onConfirmation: function () {
        dispatch(actionCoopInfoLeaveCoop());
        dispatch(actionServerPersistenceSetInfo({
            key: IdPersistence.CoopPreviousLevel,
            platform: PlayerPreferencesPlatformType.PLAT_SHARED,
            value: utilNumber.format(1),
        }));
        dispatch(actionModalClose(IdModal.CoopLeaveConfirm));
    },
}); };
export var DialogCoopLeaveConfirm = connect(mapState, mapDispatch)(DialogConfirmation);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/DialogCoopLeaveConfirm.tsx
// module id = 2566
// module chunks = 3